import { styled as muiStyled, css } from '@mui/material/styles';
import { SliceTooltipProps } from '@nivo/line';
import { TableTooltip } from '@nivo/tooltip';
import moment from 'moment';
import React from 'react';

import { RiskValueGraphDatum } from './risk-over-time-graph';

import Text from '~c/components/base/text';

interface Props extends SliceTooltipProps {
  className?: string;
}

export const convertToDateFormat = (
  date: number | string | null | undefined,
  includeTime = true
) => {
  const currentDate = date ? moment(date) : moment();

  if (includeTime) {
    return currentDate.format('MMMM Do YYYY, h:mm:ss A');
  } else {
    return currentDate.format('MMMM Do, YYYY');
  }
};

const SliceTooltipImpl: React.FC<Props> = ({ className, slice }) => {
  const riskData = slice.points[0].data as unknown as RiskValueGraphDatum;
  const date = convertToDateFormat(riskData.timestamp);

  return (
    <TableTooltip
      title={
        <Text sz="body16" sx={{ padding: '10px 0px' }}>
          {`${riskData.x} - ${date}`}
        </Text>
      }
      rows={slice.points.map((point) => {
        const pointData = point.data as unknown as RiskValueGraphDatum;
        return [
          <span
            style={{
              display: 'block',
              width: '12px',
              height: '12px',
              background: point.serieColor,
            }}
          />,
          <Text sz="body14" sx={{ padding: '3px 0px' }}>
            {point.serieId}
          </Text>,
          <strong key="value">
            {parseFloat(pointData.value ?? '0').toFixed(4)}
          </strong>,
        ];
      })}
    />
  );
};

export const SliceTooltip = muiStyled(SliceTooltipImpl)(({ theme }) => css``);

export default SliceTooltip;
